import React from 'react'
import type { Assignable } from '../../../shared/domain/schedule/assignee.no-deps'
import AssignableIcon from '../../../shared/webcomponents/react-wrappers/AssignableIcon'
import { Tooltip } from 'antd'

type Props = {
    assignables: Assignable[]
    // how many little circle icons we are going to show, including the user count icon, DEFAULT is 2 which should work for most cases
    showMaxIcons?: number
    onClick: () => void
    tooltip?: string
}

const DEFAULT_LIMIT = 2

const tooltipStyle: React.CSSProperties = {
    borderRadius: '0.4rem',
    padding: '0.4rem 1rem',
    minHeight: '0',
}

export function AssignableButton({ assignables, showMaxIcons, onClick, tooltip }: Props) {
    const limit = showMaxIcons || DEFAULT_LIMIT
    const [displayAssignables, setDisplayAssignables] = React.useState<Assignable[]>([])

    React.useEffect(() => {
        if (assignables.length === 0 || limit === 0) {
            return
        }

        if (assignables.length <= limit) {
            setDisplayAssignables(assignables)
        } else {
            setDisplayAssignables([...assignables].slice(0, limit - 1))
        }
    }, [assignables, limit])

    return (
        <Tooltip color="var(--grey-800)" placement="bottom" overlayInnerStyle={tooltipStyle} title={tooltip}>
            <button className={'AppCore__AssignableButton-button'} onClick={() => onClick()}>
                <div className={'AppCore__AssignableButton-profile-container'}>
                    {displayAssignables.map((assignable) => (
                        <span key={assignable.name} className={'AppCore__AssignableButton-profile-circle'}>
                            <AssignableIcon
                                style={
                                    {
                                        '--ProfileCircle-size-override': '24px',
                                        '--TeamCircle-size-override': '24px',
                                    } as React.CSSProperties // cast is necessary because react.CSSproperties only allows known properties
                                }
                                assignee={assignable}
                            />
                        </span>
                    ))}
                    {assignables.length > limit && (
                        <span className="AppCore__AssignableButton-profile-circle AppCore__AssignableButton-more-users-icon">
                            +{assignables.length - (limit - 1)}
                        </span>
                    )}
                </div>
            </button>
        </Tooltip>
    )
}
